"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const react_1 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const react_2 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const States_1 = require("../../lib/constants/States");
const messages_1 = __importDefault(require("../../lib/messages"));
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const styles_1 = require("./styles");
const propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    formId: prop_types_1.string,
    handleSubmit: prop_types_1.func
};
/**
 * Handles the booking process.
 * 1. Handles with formId
 * 2. Handles with incoming submit handler
 * 3. Handles when present inside a form element.
 *
 * @param {Object} param0 - The parameter object.
 * @param {instanceOf(Interpreter)} param0.service - xState service object.
 * @param {string} param0.track - Function to register tracking events.
 * @param {string} param0.size - Size of the button to be rendered.
 * @param {string} param0.handleSubmit - Submit handler for the form. (Optional in case formId is present)
 * @param {string} param0.formId - Html ID of the form, which needs to be submitted. (Optional)
 */
function BookButton(_a) {
    var { service, formId } = _a, props = __rest(_a, ["service", "formId"]);
    const [state] = (0, react_1.useService)(service);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    return (react_2.default.createElement(styles_1.StyledButtonWithSpinner, Object.assign({ aboveMd: aboveMd }, props, (formId && { form: formId }), { showSpinner: state.matches(`${States_1.patientForm}.${States_1.bookingAppt}`), disabled: state.matches(`${States_1.patientForm}.${States_1.bookingAppt}`) ||
            state.matches(`${States_1.patientForm}.${States_1.apptUnavailable}`) ||
            state.matches(`${States_1.patientForm}.${States_1.success}`) }),
        react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.bookAppointment))));
}
exports.default = BookButton;
BookButton.propTypes = propTypes;
//# sourceMappingURL=BookButton.js.map